// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__wEF5g","notes":"Notes_notes__2Jatu"};